export const pagetitle = {
    DFS: 'Exclusive Travel Rewards',
    Hotel: 'Hotel Offers',
    Enquiry: 'Generic Enquiry',
    Detail: 'Service Detail',
    Search: 'Search',
    Login: 'Login'
}

export const home = {
    recommend: 'Recommended Services',
    benefits: 'Privileges & Benefits',
    benefitsInfo: 'Discover our concierge services, travel and lifestyle experiences, customized benefits and loyalty solutions',
    contact: 'View more',
    hotline: 'Hotline',
    livechat: 'Live Chat',
    more: 'See More',
    welcometitle: 'Welcome to the DFS CIRCLE 24/7 Lifestyle Luxury Concierge',
    welcomedetail: 'Here, DFS CIRCLE top-tier members can enjoy extraordinary personalized services such as hotel bookings, restaurant recommendations, and much more.',
    welcomenotice: 'This section and the services here are provided by our partner, Aspire. All data collected will be used for the purpose of performing the services, monitoring service quality and providing internal training only.',
    selectnumber: 'Contact us via a local number',
    selectnumbertips:'Our customer service team can serve you in English, Mandarin, Cantonese or Japanese according to the location you selected.',
    selectnumbernotice:'*Depending on your service provider, local/overseas charge may apply.',
    booking: 'Transfer services Booking Instruction',
    click:'Click here'
}

export const service = {
    title: 'Book with DFS CIRCLE and enjoy exclusive benefits',
    list1: 'Unlock exclusive offers available only for Ambassador tier members',
    list2: 'Complimentary room upgrade and breakfast',
    list3: 'Early check-in and late check-out, resort and spa credits',
    tips: 'benefits offered are subject to availability',
    more: 'See More',
    less: 'See Less'
}

export const toolbar = {
    hotel: 'Hotel',
    dinning: 'Dining',
    travel: 'Travel',
    entertainment: 'Entertainment',
    club: 'Private Club',
    education: 'Education',
    golf: 'Golf',
    business: 'Business',
    reservation: 'Hotel Reservations'
}

export const category = {
    hotel: 'Hotel',
    dinning: 'Wine and Dine',
    travel: 'Airport & Travel Services',
    entertainment: 'Entertainment',
    club: 'Private Club',
    education: 'Education',
    golf: 'Golf',
    business: 'Business',
}

export const info = {
    hotel: 'Book your next vacation with our concierge services to enjoy complimentary upgrades, breakfast, and other unique VIP benefits during luxury hotel stays.',
    dinning: 'Want to visit the best restaurants and experience unique food and wine from around the world? Our concierge team will find you the best tables when you need it.',
    travel: 'Travel',
    entertainment: 'Entertainment',
    club: 'Private Club',
    education: 'Education',
    golf: 'Golf',
    business: 'Business',
    loginTitle: 'Exclusive Travel Rewards',
    loginSubtitle: 'Please log in to view your rights and more details',
    hometitle: '<span>Living your way</span>Exclusive Travel Rewards<span>Experience remarkable travel destinations and stays that will charm you, leave beautiful marks on your memory, satisfy your soul, and change your view.</span>',
    homesubtitle: '<span class="color-yellow">UnionPay Diamond Prestige Credit Card holder enjoy:</span>UnionPay Diamond Prestige credit card holders have the privilege to participate in and redeem an exclusive Travel Reward by meeting the specified spending target in accumulated eligible transactions from 1 January, 2025 to 31 December, 2025 (both dates inclusive). Redemption ends on 31 December, 2025. Utilization ends on 31 March, 2026.<br/>Each redemption submission is for a single cardholder. Monthly redemption quota applies. Redemptions open on the first day of each month and are processed on a first-come, first-served basis, subject to availability. Each transaction is eligible for a single redemption and cannot be reused for other programs. '
}

export const city = {
    hotcity: 'Popular Destination',
    shanghai: 'Shanghai',
    osaka: 'Osaka',
    singapore: 'Singapore',
    hiangmai: 'Chiang Mai',
    paris: 'Paris',
    london: 'London',
    newyork: 'New York',
    sydney: 'Sydney'
}

export const hotel = {
    title: 'Book your next vacation',
    more: 'View Details',
    location: 'Destination',
    searchcity: 'Search city',
    pickdate: 'Select dates',
    travelernumber: 'Number of travelers',
    childnumber: 'Number of children',
    nightSin: 'night',
    nightPlu: 'nights',
    room: 'Room',
    roomSin: 'room',
    roomPlu: 'rooms',
    adults: 'Adults',
    adultSin: 'adult',
    adultPlu: 'adults',
    children: 'Children',
    childSin: 'child',
    childPlu: 'children',
    travelerSin: 'traveler',
    travelerPlu: 'travelers',
    age: 'Ages 0 to 16',
    group: 'Hotel Group',
    all: 'All',
    hotcity: 'Popular Destinations',
    brandfilter: 'Hotel Group',
    pricefilter: 'Price',
    privilege: 'VIP Privileges',
    discount: 'Save up to',
    from: 'From',
    full: 'NO ROOM AVAILABLE',
    empty: 'Coming soon...',
    noroomdata: 'There are no room on the dates you have selected.',
    selectroom:'Select a room',
    roomtype: 'Room type',
    facility: 'Facilities & Services',
    policy: 'Cancellation policies',
    noncancel: 'Non-refundable',
    deadline: 'Before',
    searchtip: 'If you need hotels that are not partner hotels, please contact customer service'
}

export const buttonTxt = {
    done: 'Done',
    cancel: 'Cancel',
    search: 'Search',
    selectroom: 'Select room',
    bookroom: 'Book',
    confirmbook: 'Confirm',
    myorder: 'View My Order',
    gohome: 'Back To Home',
    reserve: 'Reserve',
    enquire: 'Enquire',
    submitEnquire: 'Submit Enquiry',
    accept: 'Accept',
    change: 'Change Booking',
    cancelOrder: 'Cancel The Order',
    confirm: 'Confirm',
    notcancel: 'Do not cancel',
    verify: 'Verify Card Number',
    upload: 'Upload'
}

export const toast = {
    title: 'Prompt',
    pickerdate: 'At least one night',
    errorEmail: 'E-mail format is incorrect',
    errorName: 'Use English',
    unLogin: 'User is not logged in',
    nologin: 'Missing user information, please log in again',
    cancelTitle: 'Confirm to cancel the order?',
    cancelTip: 'Cancel the order will not be restored, are you sure to cancel?',
    cancelsuccess:'Cancel Success',
    cancelfailed:'Cancel Failed',
    requesterror:'Booking failed. Please try again later',
    uploaderror:'Upload failed. Please resize or change the file.',
    validateError: 'Card number verification failed',
    missSession: 'No payment information available',
    paymentSuccess: 'Payment successful',
    paymentFail: 'Payment Failed',
    paymentNotice: 'Due to a system upgrade, for Cardholder holding card # starting 626310 / 626311, please contact our concierge service hotline at 852-2603-9512 if the payment cannot go through.  We apologize for any inconvenience caused.',
    errorTime: 'Unavilabe time period'
}

export const form = {
    master: 'Primary cardholder',
    yes: 'Yes',
    no: 'No',
    noValidate: '',
    searchcity: 'Search city',
    searchkey: 'Search keywords',
    roomnumber: 'Number of Rooms',
    peopleNumber: 'Number of bookings',
    checkin: 'Check-in date',
    checkout: 'Check-out date',
    cost: 'Total price',
    price: 'Room rate',
    other: 'Other',
    tax: 'Tax & service charge',
    information: 'CONTACT INFORMATION',
    name: 'Name',
    gender: 'Title',
    male: 'Mr.',
    female: 'Ms.',
    firstname: 'First name',
    lastname: 'Last name',
    contactmobile: 'Phone Number',
    areacode: 'Area code',
    mobile: 'Phone number',
    contactemail: 'Contact Email',
    emailaddress: 'Email address',
    contacttime: 'Preferred Contact Time',
    dateperiod: 'Your preferred date',
    timeperiod: 'Your preferred time',
    timedetail: 'Select your preferred date and time for our luxury concierge to reach out to you.',
    fqt: 'Frequent Traveller Program Code',
    fqttip: 'Please confirm with the hotel when you check in.',
    codenumber: 'Frequent travel plan code',
    special: 'Special Requirements',
    specialtip: 'Please type your request here. Maximum 200 characters.',
    payment: 'PAYMENT DETAILS',
    paymentmethod: 'Payment method',
    cardtype: 'Card type',
    cardnumber: 'Card number',
    expiration: 'Expiration Date',
    month: 'MM',
    year: 'YY',
    creditcard: 'Credit Card',
    success: 'Reservation successful!',
    enquiresent: 'Enquiry sent',
    successnotice: 'We have received your enquiry and will contact you as soon as possible.',
    contactdetail: 'We will reach out via email, SMS, or call regarding the service you have booked.',
    contactmethod: 'Preferred Contact Method',
    phonecall: 'Phone Call',
    email: 'Email',
    anyday: 'Any Day',
    weekday: 'Weekdays',
    weekend: 'Weekend',
    anytime: 'Any Time',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    additional: 'Additional Request',
    additionaltip: 'If you have any special requests, please let us know below.',
    attendeenumber: 'Number of Guests',
    attendee: 'Guest',
    reservedate: 'Reservation Time',
    // time: 'Please choose reservation time',
    time: "Departure transfer pick-up times must be scheduled no less than 3 hours before the flight's departure.",
    // time: 'The earliest available booking date is October 16th',
    call: 'Call to',
    isrequired:'Is required',
    cardNumberTip: 'Please enter the 16-digit card number',
    upload: 'Upload for review',
    uploadtips: 'Upload bank statement of accumulated retail spending of HKD 4,000 or more using the same Eligible Card (“Eligible Transactions”) within the latest two consecutive natural months (Up to 2 images. Support jpg, png and pdf)',
    peopleunit: 'people',
    departure: 'Departure',
    departureInput: 'Please enter departure',
    airport:'Please choose airport',
    destination: 'Destination',
    destinationInput: 'Please enter destination',
    flightNo: 'Flight Number',
    flightNoInput: 'Please enter flight number',
    carType: 'Choose car',
    pickup:'PICK UP INFORMATION',
    dropoff: 'DROP OFF INFORMATION',
    clause: "HKD100 per ride for pick-up between 00:00 & 05:59.<br/>Maximum free waiting period shall be 75 minutes from flight landing time for arrival transfer), or 15 minutes from the agreed pick-up time for departure transfer. Additional charge may apply for extended waiting.<br/>Departure transfer pick-up times must be scheduled no less than 3 hours before the flight's departure.<br/>Maximum 4 standard-size suitcases (22'' x 12'' x 30'')",
    addFee: 'Additional charge',
    luggage: 'Luggage',
    luggageInput:'Number of luggage'
}

export const order = {
    checkin: 'check in',
    checkout: 'check out',
    total: 'Total',
    reservation: 'Order date',
    success: 'Success',
    cancel: 'Cancelled',
    name: 'Full name',
    phone: 'Phone Number',
    email: 'Email',
    useDate: 'Appointment date',
    special: 'Special Requirements',
    cancelTxt: 'Cancel the order',
    confirm:'Confirm cancellation of the order?',
    failed: 'Cancel failed',
    price: 'Order Amount'
}

export const other = {
    hotcity: 'Popular Destinations',
    address: 'Location',
    summary: 'Summary',
    details: 'Details',
    clause: 'Terms',
    service: 'Make an Enquiry',
    reservation: 'Enquiry and Reservation',
    terms: 'Terms & Conditions',
    termsdetail: '<p>1. Certain room types are not eligible for room upgrades or special offers.</p><p>2. If there is any change in the room type, the hotel reserves the right of final interpretation.</p><p>3. Not all participating hotels offer in-room Wi-Fi benefits. Please call the customer service hotline for more details.</p><p>4. Hotel experience privileges vary by hotel, please call the customer service hotline for more details.</p>',
    domestic:'China',
    searchKey: 'Please input search keywords',
    basePrice:'original price',
    activePrice: 'current price',
    tc: 'TERMS AND CONDITIONS',
    time: 'Opening Hour',
    timedetail: '24 hours daily | Monday to Sunday'
}

export const telephone = {
    China: 'China',
    Macao: 'Macao',
    Japan: 'Japan',
    HongKong: 'HongKong',
    Guam: 'Guam',
    Australia: 'Australia',
    France: 'France'
}

export const login = {
    phoneNumber: 'Phone Number',
    code: 'Verification code',
    send: 'Send',
    login: 'Sign In',
    errorPhoneNumber: 'The phone number is incorrect',
    failSend: 'Sending failed',
    emptyCode: 'Verification code is Empty',
    failVerify: 'Verification failed'
}


// WEBPACK FOOTER //
// ./src/language/english.js